module.exports = __webpack_public_path__ + "img/cloud.aa166232.svg";